<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">公告列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small">发布公告</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '发布公告' : '编辑公告'"
      footer-hide
      width="600"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="16">
            <FormItem label="公告标题" prop="title">
              <Input v-model="item.title" placeholder="请输入"></Input>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem label="公告等级" prop="level">
              <Select v-model="item.level">
                <Option
                  v-for="(x, index) in $t('level')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="公告内容" prop="content">
              <Input type="textarea" v-model="item.content"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "公告标题",
          key: "title",
        },
        {
          title: "公告内容",
          key: "content",
        },
        {
          title: "公告等级",
          key: "level",
          render: (h, data) => {
            return h("div", this.$t("level." + data.row.level));
          },
        },
        {
          title: "发布时间",
          key: "publishTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.publishTime));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        content: "",
        level: "1",
        platformIdList: [],
        title: "",
        remarks: "",
      },
      ruleValidate: {
        title: { required: true, message: "必填" },
        content: { required: true, message: "必填" },
        platformIdList: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.msg + "/bulletin/csr/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.axios({
              method: "post",
              url: this.axios.msg + "/bulletin/csr/publish",
              data: this.item,
            }).then((res) => {
              
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } 
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.msg + "/bulletin/csr/del",
            data: { idList: [row.id] },
          }).then((res) => {
            console.log(res);
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
  },
  mounted() {
    this.getList();
    // this.getPlatform();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// ../common/src/components/alarm/fbgg.vue